import api from '../api'

const userBaseUrl = '/People/api/People'
const baseUrl = '/academy/api/AdminCourse'

const dadbanUsersProvider = {
  getSearchUsers(params) {
    return api.get(`${userBaseUrl}/SearchPeople` + params)
  },

  getUser(params) {
    return api.get(`${baseUrl}/EditUser/${params}`)
  },

  addUsersExcel(productId, productType, description, price, params) {
    return api.post(`/academy/api/AdminOrder/AddRange?productId=${productId}&productType=${productType}&description=${description}&price=${price}`, params)
  },
  addFreeUsersExcel(productId, productType, params) {
    return api.post(`${baseUrl}/ProductPeoples?productId=${productId}&productType=${productType}`, params)
  },
  addSearchUser(params) {
    return api.post(`/academy/api/AdminOrder/Add`, params)
  },

  addFreeSearchUser(params) {
    return api.post(`${baseUrl}/ProductPeople`, params)
  },

  creatSearchUser(params) {
    return api.post(`${baseUrl}/People`, params)
  },

  updateUser(params = {}) {
    return api.put(`${baseUrl}/User`, params)
  },

  deleteCourseUser(params) {
    return api.delete(`${baseUrl}/ProductPeople/${params}`)
  },

  createTeacherUser(params = {}) {
    return api.post(userBaseUrl, params)
  },

  getUserById(params) {
    return api.get(`${userBaseUrl}/GetById?peopleId=${params}`)
  },
}

export default dadbanUsersProvider
